module.exports = __webpack_public_path__ + "img/illustrations.413c6164.png";